<template>
  <div class="parentReport">
    <div class="positionbtns">
      <button
        class="butt"
        style="background-color: #6372ff"
        @click="downloadPdf('print')"
      >
        打印
      </button>
      <button
        class="butt"
        style="background-color: #6372ff"
        @click="downloadImg"
      >
        导出图片
      </button>
      <button
        class="butt"
        style="background-color: #6372ff"
        @click="downloadPdf"
      >
        导出pdf
      </button>
    </div>
    <!-- 从这里开始打印 -->
    <div id="myChart" class="myChart">
      <div id="pdfcontent" ref="reportBox" class="report-box">
        <div class="department-container">
          <div class="header">
            <div class="title">《学职定位综合报告》</div>
            <div class="userInfo">
              <!-- <div class="name">姓名：{{ name }}</div>
              <div class="timer">测评时间：{{ createTime }}</div> -->
            </div>
          </div>
          <div class="main">
            <div class="introduce">
              <div class="introduce_content">
                《学生职业规划与定位测评系统》是通过对学生的“兴趣、性格、能力、价值观”等维度综合测评和深入剖析，让你进一步了解自己喜欢做什么？适合做什么？擅长做什么？最看重什么？学科强弱程度，同时明确指出各维度的类型及其特征，从而为广大学生确定自身专业定位和规划未来的职业生涯，提供系统、全面、具体、有针对性的指导和决策参考。
              </div>
            </div>
            <div class="navBar">
              <div class="navBar_t">
                <div class="tag">
                  <a href="javascript:" @click="goAnchor('#兴趣')">兴趣</a>
                </div>
                <div class="tag">
                  <a href="javascript:" @click="goAnchor('#性格')">性格</a>
                </div>
                <div class="tag">
                  <a href="javascript:" @click="goAnchor('#能力')">能力</a>
                </div>
                <div class="tag">
                  <a href="javascript:" @click="goAnchor('#职业价值观')"
                    >职业价值观</a
                  >
                </div>
                <!-- <div class="tag">
                  <a href="javascript:" @click="goAnchor('#学力评估')"
                    >学力评估</a
                  >
                </div> -->
                <div class="tag">
                  <a href="javascript:" @click="goAnchor('#代表人物')"
                    >代表人物</a
                  >
                </div>
                <div class="tag">
                  <a href="javascript:" @click="goAnchor('#专业推荐')"
                    >专业推荐</a
                  >
                </div>
              </div>
              <div class="navBar_b"></div>
            </div>
            <div class="test">
              <div class="test_content">
                <div class="l">
                  <div class="left_logo">
                    <img src="./images/yq.png" alt="" />
                  </div>
                  <div id="兴趣" class="left_title">兴趣纬度</div>
                </div>
                <div class="x"></div>
                <div class="r">
                  <div class="right_title">Interest dimension</div>
                </div>
              </div>
              <div class="exponent">
                <div class="exponent_title">
                  您的性格类型：{{ Holland.title }}
                </div>
                <div class="details">
                  {{ Holland.description }}
                </div>
                <div class="picture">
                  <div class="a">
                    <RadarOne :picCharts="Holland.picCharts" />
                  </div>
                </div>
                <div class="table">
                  <el-table
                    :data="Holland.reportItems"
                    style="width: 100%; font-size: 10px"
                    border
                    stripe
                    :header-cell-style="{
                      background: '#d7e0fa',
                      color: '#333333',
                    }"
                  >
                    <el-table-column label="类型" align="center" width="80">
                      <template slot-scope="scope">
                        <span
                          style="font-size: 13px; color: #333; font-weight: 600"
                          >{{ scope.row.tag }}</span
                        >
                        <div
                          style="font-size: 13px; color: #333; font-weight: 600"
                        >
                          {{ scope.row.title }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="traits"
                      label="共同特征"
                      align="center"
                      width="200"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="resolving"
                      label="性格特点"
                      align="center"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="occupation"
                      label="适合职业"
                      align="center"
                    >
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
            <div class="test">
              <div class="test_content">
                <div class="l">
                  <div class="left_logo">
                    <img src="./images/yq.png" alt="" />
                  </div>
                  <div id="性格" class="left_title">性格维度</div>
                </div>
                <div class="x"></div>
                <div class="r">
                  <div class="right_title">Interest dimension</div>
                </div>
              </div>
              <div class="result">
                <div class="top">
                  <div class="title">
                    <div class="title_t">您的性格类型：{{ MBTID.title }}</div>
                    <div class="title_c">
                      {{ MBTID.description }}
                    </div>
                    <div class="pic">
                      <div class="pic_left">
                        <div class="pic_one">
                          <div class="one_left">
                            {{ MBTID.linChart.name[0] }}
                          </div>
                          <div class="one_hs">
                            <div
                              class="_ls"
                              :style="{
                                width: MBTID.linChart.value[0] * 20 + `%`,
                              }"
                            ></div>
                          </div>
                        </div>
                        <div class="pic_one">
                          <div class="one_left">
                            {{ MBTID.linChart.name[1] }}
                          </div>
                          <div class="one_hs">
                            <div
                              class="_ls"
                              :style="{
                                width: MBTID.linChart.value[1] * 20 + `%`,
                              }"
                            ></div>
                          </div>
                        </div>
                        <div class="pic_one">
                          <div class="one_left">
                            {{ MBTID.linChart.name[2] }}
                          </div>
                          <div class="one_hs">
                            <div
                              class="_ls"
                              :style="{
                                width: MBTID.linChart.value[2] * 20 + `%`,
                              }"
                            ></div>
                          </div>
                        </div>
                        <div class="pic_one">
                          <div class="one_left">
                            {{ MBTID.linChart.name[3] }}
                          </div>
                          <div class="one_hs">
                            <div
                              class="_ls"
                              :style="{
                                width: MBTID.linChart.value[3] * 20 + `%`,
                              }"
                            ></div>
                          </div>
                        </div>
                      </div>
                      <div class="pic_right">
                        <div class="pic_two">
                          <div class="one_hs">
                            <div
                              class="_ls"
                              :style="{
                                width: MBTID.linChart.value[4] * 20 + `%`,
                              }"
                            ></div>
                          </div>
                          <div class="one_left">
                            {{ MBTID.linChart.name[4] }}
                          </div>
                        </div>
                        <div class="pic_two">
                          <div class="one_hs">
                            <div
                              class="_ls"
                              :style="{
                                width: MBTID.linChart.value[5] * 20 + `%`,
                              }"
                            ></div>
                          </div>
                          <div class="one_left">
                            {{ MBTID.linChart.name[5] }}
                          </div>
                        </div>
                        <div class="pic_two">
                          <div class="one_hs">
                            <div
                              class="_ls"
                              :style="{
                                width: MBTID.linChart.value[6] * 20 + `%`,
                              }"
                            ></div>
                          </div>
                          <div class="one_left">
                            {{ MBTID.linChart.name[6] }}
                          </div>
                        </div>
                        <div class="pic_two">
                          <div class="one_hs">
                            <div
                              class="_ls"
                              :style="{
                                width: MBTID.linChart.value[7] * 20 + `%`,
                              }"
                            ></div>
                          </div>
                          <div class="one_left">
                            {{ MBTID.linChart.name[7] }}
                          </div>
                        </div>
                      </div>
                      <!-- <TwoHistogram :MBTID="MBTID.linChart" /> -->
                    </div>
                  </div>
                </div>
                <div class="body">
                  <div class="body_top">
                    <div class="body_header">
                      <img src="./images/sj.png" alt="" />
                    </div>
                    <div class="body_title">主要特征</div>
                  </div>
                  <div class="body_btn" v-html="MBTID.reportItem.features">
                   
                  </div>
                </div>
                <div class="body">
                  <div class="body_top">
                    <div class="body_header">
                      <img src="./images/sj.png" alt="" />
                    </div>
                    <div class="body_title">适合领域</div>
                  </div>
                  <div class="body_btn">
                    {{ MBTID.reportItem.mainDomain }}
                  </div>
                </div>
                <div class="body">
                  <div class="body_top">
                    <div class="body_header">
                      <img src="./images/sj.png" alt="" />
                    </div>
                    <div class="body_title">相关专业</div>
                  </div>
                  <div class="body_btn">
                    {{ MBTID.reportItem.major }}
                  </div>
                </div>
                <div class="body">
                  <div class="body_top">
                    <div class="body_header">
                      <img src="./images/sj.png" alt="" />
                    </div>
                    <div class="body_title">适合职业</div>
                  </div>
                  <div class="body_btn">
                    {{ MBTID.reportItem.occupation }}
                  </div>
                </div>
              </div>
            </div>
            <div class="test">
              <div class="test_content">
                <div class="l">
                  <div class="left_logo">
                    <img src="./images/yq.png" alt="" />
                  </div>
                  <div id="能力" class="left_title">能力纬度</div>
                </div>
                <div class="x"></div>
                <div class="r">
                  <div class="right_title">Competency dimension</div>
                </div>
              </div> 
              <div class="result">
                <div class="top">
                  <div class="title">
                    <div class="title_t">
                      {{ Ability.title }}
                    </div>
                    <div class="title_c">
                      {{ Ability.description }}
                    </div>
                    <div class="pic1">
                      <Histogram :linChart="Ability.linChart" />
                    </div>
                  </div>
                </div>
                <div class="body1">
                  <div
                    class="bodyBox"
                    v-for="(it, index) in Ability.reportItems"
                    :key="index"
                  >
                    <div class="body_left">
                      <div class="body_left_t">{{ it.title }}</div>
                      <div class="body_left_b">
                        {{ it.resolving }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="test">
              <div class="test_content">
                <div class="l">
                  <div class="left_logo">
                    <img src="./images/yq.png" alt="" />
                  </div>
                  <div id="职业价值观" class="left_title">价值观纬度</div>
                </div>
                <div class="x"></div>
                <div class="r">
                  <div class="right_title">Value dimension</div>
                </div>
              </div>
              <div class="result">
                <div class="top">
                  <div class="title">
                    <div class="title_t">
                      您的职业价值观： {{ Opinion.tag }}
                    </div>
                    <div class="title_c">
                      {{ Opinion.description }}
                    </div>
                    <div class="title_D">
                      <div class="pic3">
                        <ZZYOne :picCharts="Opinion.opinionItems" />
                      </div>
                    </div>
                    <!-- <div class="table2" v-if="Opinion">
                      <el-table
                        :row-style="{ height: 30 + 'px' }"
                        :data="Opinion.opinionItems"
                        style="width: 100%; font-size: 10px"
                        border
                        stripe
                        :header-cell-style="{
                          background: '#d7e0fa',
                          color: '#333333',
                        }"
                      >
                        <el-table-column
                          prop="name"
                          label="因子"
                          align="center"
                        >
                        </el-table-column>
                        <el-table-column
                          prop="value"
                          label="得分"
                          align="center"
                        >
                        </el-table-column>
                        <el-table-column prop="max" label="满分" align="center">
                        </el-table-column>
                      </el-table>
                    </div> -->

                    <div class="title_E" v-if="Opinion">
                      <el-table
                        :row-style="{ height: 30 + 'px' }"
                        :data="Opinion.reportItems"
                        style="width: 100%; font-size: 10px"
                        border
                        stripe
                        :header-cell-style="{
                          background: '#d7e0fa',
                          color: '#333333',
                        }"
                      >
                        <el-table-column
                          prop="tag"
                          label="类型"
                          align="center"
                          width="200"
                        >
                        </el-table-column>
                        <el-table-column
                          prop="description"
                          label="详解"
                          align="center"
                        >
                        </el-table-column>
                      </el-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="test">
              <div class="test_content">
                <div class="l">
                  <div class="left_logo">
                    <img src="./images/yq.png" alt="" />
                  </div>
                  <div id="学力评估" class="left_title">学科优势纬度</div>
                </div>
                <div class="x"></div>
                <div class="r">
                  <div class="right_title">Discipline advantage dimension</div>
                </div>
              </div>
              <div class="exponent">
                <div class="exponent_title">
                  您的优势学科为：历史+英语+地理(偏文科)
                </div>
                <div class="details">
                  你在历史这门学科上的优势较大，这说明你本身能够博览史书，学习能力强，同时能够见微知著，客观辩证的分析、理解、借
                  鉴历史，同时自信心强，善于旁征博引，口才好。你在数学的学科上较为薄弱，可以多进行数学学习，通过解决问题为载体，
                  认识数学思维活动的特点。
                </div>
                <div class="picture">
                  <div class="a">
                    <RadarOne :picCharts="Holland.picCharts" />
                  </div>
                </div>
              </div>
            </div> -->
            <div class="test">
              <div class="test_content">
                <div class="l">
                  <div class="left_logo">
                    <img src="./images/yq.png" alt="" />
                  </div>
                  <div id="代表人物" class="left_title">代表人物</div>
                </div>
                <div class="x"></div>
                <div class="r">
                  <div class="right_title">Professional recommendation</div>
                </div>
              </div>
              <div class="exponent">
                <div class="exponent_title">以下代表人物仅作为参考：</div>
                <div class="detailss">
                  <div class="item" v-for="(it, idx) in figureList" :key="idx">
                    <div class="name">{{ it.nickName }}</div>
                    <div class="photo">
                      <img :src="it.avatarUrl" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="test">
              <div class="test_content">
                <div class="l">
                  <div class="left_logo">
                    <img src="./images/yq.png" alt="" />
                  </div>
                  <div id="专业推荐" class="left_title">专业推荐</div>
                </div>
                <div class="x"></div>
                <div class="r">
                  <div class="right_title">Professional recommendation</div>
                </div>
              </div>
              <div class="exponent">
                <div class="exponent_title">以下专业推荐仅作为参考：</div>
                <div class="table">
                  <el-table
                    :row-style="{ height: 30 + 'px' }"
                    :data="photoList"
                    border
                    stripe
                    :header-cell-style="{
                      background: '#d7e0fa',
                      color: '#333333',
                    }"
                  >
                    <el-table-column
                      prop="tradeName"
                      label="专业大类"
                      align="center"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="categoryName"
                      label="专业类"
                      align="center"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="name"
                      label="专业名称"
                      align="center"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="tag"
                      width="90"
                      label="标签"
                      align="center"
                    >
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </div>
          <div class="base">
            <div class="leftlogo">
              <div class="base_logo" style="width: 200px">
                <img src="./images/log.png" alt="" />
              </div>
            </div>
            <div class="rightlogo">
              <div class="base_wenzi" style="margin-right: 20px">
                长按识别二维码 你也来测试一下吧～
              </div>
              <div class="base_logo"><img src="./images/ewm.png" alt="" /></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import ExportSavePdf from "@/utils/html2pdf";
import { formatTime } from "@/utils/index.js";
import RadarOne from "./RadarOne.vue";
import ZZYOne from "./ZZYOne.vue";
import Histogram from "./histogram.vue";
// import TwoHistogram from "./TwoHistogram.vue";
import {
  GetReportMapIds,
  GetHollandDimension,
  GetMBTIDimension,
  GetAbilityDimension,
  GetOpinionAbout,
  getTagMapPro,
  getTagMapPerson,
} from "@/api/home";
export default {
  name: "HSasAnxiety",
  components: {
    RadarOne,
    ZZYOne,
    Histogram,
  },
  props: {},
  data() {
    return {
      name: "",
      createTime: "",
      ids: "",
      widths: "300px",
      Holland: "",
      MBTID: "",
      Ability: "",
      Opinion: "",
      figureList: [],
      photoList: [],
      tableData: [
        {
          date: "文学",
          name: "中国语言文学类",
          address: "汉语言文学",
          f: "72%",
        },
        {
          date: "文学",
          name: "新闻传播学类",
          address: "新闻学",
          f: "66%",
        },
      ],
    };
  },

  mounted() {
    this.createTime = this.$route.query.createTime || "";
    this.name = this.$store.state.user.studentInfo || "";
    this.Getprehensive(this.$route.query.id);
  },

  methods: {
    goAnchor(selector) {
      this.$el.querySelector(selector).scrollIntoView({
        behavior: "smooth", //平滑过度
        block: "start",
      });
    },
    // 获取综合报告所需的id
    async Getprehensive(ReportId) {
      const res = await GetReportMapIds(ReportId);
      this.ids = res.data || res.result;
      this.GetHolland(this.ids.hId);
      this.GetMBTID(this.ids.mId);
      this.GetAbility(this.ids.nId);
      this.GetOpinion(this.ids.jId);
    },
    // 获取霍兰德报告
    async GetHolland(ScaleId) {
      const res = await GetHollandDimension(ScaleId);
      this.Holland = res.data || res.result;

      await this.GetTagMap(this.Holland.hTag);
      await this.GetTag(this.Holland.hTag);
    },
    // 获取BTID报告
    async GetMBTID(ScaleId) {
      const res = await GetMBTIDimension(ScaleId);
      this.MBTID = res.data || res.result;
    },
    // 获取能力维度报告
    async GetAbility(ScaleId) {
      const res = await GetAbilityDimension(ScaleId);
      this.Ability = res.data || res.result;
    },
    // 获取职业锚维度报告
    async GetOpinion(ScaleId) {
      const res = await GetOpinionAbout(ScaleId);
      this.Opinion = res.data || res.result;
    },
    // 获取代表人物
    async GetTagMap(tag) {
      const res = await getTagMapPro(tag);
      this.photoList = res.data || res.result;
    },
    // 获取代表人物
    async GetTag(tag) {
      const res = await getTagMapPerson(tag);
      this.figureList = res.data || res.result;
    },
    // 导出pdf
    downloadPdf(type) {
      ExportSavePdf(
        "pdfcontent",
        `${this.name}的综合报告`,
        formatTime(new Date()),
        type
      );
    },
    /**
     * 下载图片
     */
    downloadImg() {
      console.log("download ....");
      html2canvas(document.querySelector("#myChart")).then((canvas) => {
        const url = canvas.toDataURL();
        this.downloadFile(url, `${this.name}的综合报告`);
      });
    },
    /**
     * @description Base64转Blob
     * @param dataUrl base64地址
     */
    dataURLtoBlob(dataurl) {
      const arr = dataurl.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    /**
     * @description 构建a标签，通过a标签下载文件
     * @param url 下载地址
     * @param name 下载的文件名
     */
    downloadFile(url, name = "图片") {
      const a = document.createElement("a");
      a.setAttribute("href", url);
      a.setAttribute("download", name);
      a.setAttribute("target", "_blank");
      const clickEvent = document.createEvent("MouseEvents");
      clickEvent.initEvent("click", true, true);
      a.dispatchEvent(clickEvent);
    },
    /**
     * @description 将得到的base64文件转码下载
     * @param base64 图片base64编码
     * @param name 文件名称
     */
    downloadFileByBase64(base64, name) {
      const myBlob = this.dataURLtoBlob(base64);
      const myUrl = URL.createObjectURL(myBlob);
      this.downloadFile(myUrl, name);
    },
  },
};
</script>

<style lang="less" scoped media="print">
@media print {
  @page {
    margin: 0;
  }
  body {
    margin: 0 1mm 1cm 0; // 此处样式根据实际需要进行设置
  }
}
.parentReport {
  .positionbtns {
    position: fixed;
    width: 100px;
    transform: translateX(467px);
    top: 85px;
    left: 0;
    right: 0;
    margin: auto;
    text-align: right;
    z-index: 1000;
    .butt {
      width: 100px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      margin-bottom: 15px;
      color: #fff;
      font-size: 14px;
      cursor: pointer;
      border-radius: 3px;
      border: 0;
      //   box-shadow: 0 2px 4px rgb(0 0 0 / 12%), 0 0 6px rgb(0 0 0 / 4%);
    }
  }
  .report-box {
    width: 794px;
    margin: 0 auto;
    background: #fff;
    .department-container {
      width: 100%;
      font-size: 12px;
      background-image: url("./images/background2.png") !important;
      padding-bottom: 1em;
      box-sizing: border-box;
      background-size: cover;
      .base {
        display: flex;
        justify-content: space-evenly;
        .leftlogo {
          display: flex;
          align-items: center;
          .base_logo {
            width: 35px;
            height: 35px;
            img {
              width: 100%;
            }
          }
          .base_wenzi {
            font-size: 16px;
            color: #fff;
          }
        }
        .rightlogo {
          display: flex;
          align-items: center;
          .base_wenzi {
            font-size: 16px;
            color: #fff;
          }
          .base_logo {
            width: 60px;
            height: 60px;
            img {
              width: 100%;
            }
          }
        }
      }
      .header {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #fff;
        .title {
          font-size: 36px;
          margin: 86px 0 27px 0;
        }
        .userInfo {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          .name {
            margin-right: 50px;
          }
        }
      }

      .main {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: auto;
        margin: 25px 30px 30px 30px;
        padding: 40px 40px 70px 40px;
        background: #fff;
        border-radius: 41px 41px 41px 41px;
        box-sizing: border-box;
        .introduce {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 140px;
          background: #dae8ff;
          border-radius: 5px 5px 5px 5px;
          opacity: 1;
          .introduce_content {
            margin: 0 40px;
            font-size: 13px;
            color: #333;
            line-height: 20px;
          }
        }
        .navBar {
          width: 100%;
          margin-top: 20px;
          margin-bottom: 40px;
          .navBar_t {
            display: flex;
            align-items: center;
            justify-content: left;
            .tag {
              width: calc(100% / 9);
              height: 30px;
              background: #dae8ff;
              opacity: 1;
              border-radius: 12px 12px 0 0;
              margin-left: 14px;
              text-align: center;
              line-height: 30px;
              color: #3964e6;
              font-weight: bold;
              cursor: pointer;
              a {
                text-decoration: none;
              }
            }
            .download {
              width: 100px;
              height: 30px;
              background: #3964e6;
              opacity: 1;
              margin-left: 25px;
              border-radius: 10px 10px 10px 10px;
              text-align: center;
              color: #fff;
              line-height: 30px;
              font-size: 14px;
              font-weight: bold;
              cursor: pointer;
            }
          }
          .navBar_b {
            width: 100%;
            height: 0.5px;
            background: #3964e6;
            border-radius: 0px 0px 0px 0px;
            opacity: 1;
          }
        }
        .test {
          width: 614px;
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-top: 10px;
          position: relative;
          .test_content {
            width: 100%;
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            justify-content: space-between;
            .l {
              display: flex;
              .left_logo {
                width: 25px;
                height: 15px;
                margin-right: 12px;
                img {
                  width: 100%;
                }
              }
              .left_title {
                font-size: 16px;
                color: #333;
                font-weight: bold;
                padding-right: 10px;
                font-size: 14px;
              }
            }
            .x {
              position: absolute;
              top: 21px;
              left: 110px;
              width: 70%;
              height: 1px;
              background: #e2e2e2;
              border-radius: 0px 0px 0px 0px;
              opacity: 1;
            }
            .r {
              .right_title {
                height: 20px;
                font-size: 7px;
                color: #c7c3c3;
                border-bottom: solid 2px #d9d9d9;
                margin-bottom: 20px;
                text-align: center;
              }
            }
          }
          .exponent {
            width: 90%;
            opacity: 1;
            display: flex;
            flex-direction: column;
            margin-bottom: 47px;
            .exponent_title {
              font-size: 14px;
              font-weight: bold;
              color: #3964e6;
              margin-bottom: 8px;
            }
            .details {
              color: #666666;
              margin-bottom: 15px;
            }
            .detailss {
              color: #666666;
              margin-bottom: 15px;
              display: flex;
              flex-wrap: wrap;
              .item {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                width: 25%;
                height: 120px;
                .photo {
                  margin-top: 10px;
                  width: 60px;
                  height: 60px;
                  img {
                    width: 100%;
                    height: 100%;
                  }
                }
              }
            }
            .picture {
              display: flex;
              align-items: center;
              justify-content: center;
              .a {
                width: 100%;
                height: 100%;
              }
            }
            .table {
              margin-top: 24px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
          .result {
            min-width: 614px;
            .top {
              .title {
                color: #666;
                margin-left: 40px;
                .title_t {
                  font-size: 14px;
                  color: #3964e6;
                  font-weight: bold;
                  margin-bottom: 30px; //#FF5925
                }
                .title_c {
                  width: 100%;
                  font-size: 13px;
                  color: #666;
                  margin-bottom: 30px;
                }
                .pic {
                  width: 100%;
                  display: flex;
                  justify-content: center;
                  .pic_left {
                    margin-right: 20px;
                    .pic_one {
                      display: flex;
                      align-items: center;
                      margin-bottom: 20px;
                      .one_left {
                        width: 50px;
                        margin-right: 10px;
                      }
                      .one_hs {
                        position: relative;
                        width: 230px;
                        height: 10px;
                        background: #f0f0f0;
                        border-radius: 9px 9px 9px 9px;
                        opacity: 1;
                        ._ls {
                          position: absolute;
                          top: 0;
                          right: 0;
                          width: 100px;
                          height: 10px;
                          background: #b6d6ff;
                          border-radius: 9px 9px 9px 9px;
                          opacity: 1;
                        }
                      }
                    }
                  }
                  .pic_right {
                    margin-right: 30px;
                    .pic_two {
                      display: flex;
                      align-items: center;
                      margin-bottom: 20px;
                      .one_left {
                        width: 50px;
                        margin-left: 10px;
                      }
                      .one_hs {
                        position: relative;
                        width: 230px;
                        height: 10px;
                        background: #f0f0f0;
                        border-radius: 9px 9px 9px 9px;
                        opacity: 1;
                        ._ls {
                          position: absolute;
                          top: 0;
                          left: 0;
                          width: 110px;
                          height: 10px;
                          background: #b6d6ff;
                          border-radius: 9px 9px 9px 9px;
                          opacity: 1;
                        }
                      }
                    }
                  }
                }
                .pic1 {
                  width: 90%;
                  height: 300px;
                }
                .title_D {
                  display: flex;
                  width: 100%;
                  margin-bottom: 30px;
                  .pic3 {
                    width: 100%;
                  }
                }
                .table2 {
                  width: 100%;
                  margin-bottom: 40px;
                }
                .title_E {
                  width: 100%;
                  margin-bottom: 40px;
                }
              }
            }
            .body {
              margin: 20px 30px 0 40px;
              color: #666666;
              .body_top {
                display: flex;
                margin-bottom: 10px;
                .body_header {
                  margin-right: 10px;
                }
                .body_title {
                  font-size: 12px;
                  color: #666666;
                  font-weight: bold;
                }
              }

              .body_btn {
                margin-left: 15px;
                font-size: 13px;
              }
            }
            .body1 {
              display: flex;
              margin-top: 10px;
              justify-content: space-between;
              flex-wrap: wrap;
              width: 100%;
              .bodyBox {
                width: 50%;
                margin-top: 20px;
                .body_left {
                  margin-left: 13%;
                  .body_left_t {
                    font-size: 14px;
                    font-weight: bold;
                    color: #333333;
                    margin-bottom: 8px;
                  }
                  .body_left_b {
                    width: 90%;
                    color: #666;
                    font-size: 10px;
                  }
                }
              }
            }
          }
        }
      }
      ::v-deep .el-table__header-wrapper {
        thead {
          th {
            div {
              font-weight: 600;
              font-size: 14px;
            }
          }
        }
      }
      ::v-deep .el-table__body {
        border-collapse: separate !important;
        border-spacing: 0 5px !important;
        table-layout: auto !important;
      }
      ::v-deep .el-table,
      .el-table__expanded-cell {
        background-color: transparent !important;
      }
      ::v-deep .el-table--enable-row-transition .el-table__body td,
      .el-table .cell {
        background-color: transparent;
      }

      //google chrome explore
      -webkit-print-color-adjust: exact;
      //firefox  explore
      -moz-print-color-adjust: exact;
      color-adjust: exact;
    }
  }
}
</style>
